import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { Observable } from 'rxjs';
import { AlertModalComponent } from '../shared/alert-modal/alert-modal.component';

@Injectable({
  providedIn: 'root',
})
export class AlertDialogService {
  DialogRef: any;
  constructor(private dialog: MatDialog) {}

  openAlertModal(
    status: string,
    title?: string,
    message?: string,
    confirmBtn?: string,
    cancelBtn?: string,
    width?: string,
    disableClose: boolean = false,
    icon?: string
  ): Observable<any> {
    if (status === 'success') {
      this.DialogRef = this.dialog.open(AlertModalComponent, {
        autoFocus: false,
        panelClass: 'dialog-modal',
        width: width,
        disableClose: disableClose,
        scrollStrategy: new NoopScrollStrategy(),
        data: {
          title,
          // title: 'Thank you !',
          message,
          // message: 'An email has been sent to your address.',
          status,
          cancelBtn,
          confirmBtn,
          icon: icon || 'assets/icons/circle-ok.svg',
        },
      });
    } else if (status === 'error') {
      this.DialogRef = this.dialog.open(AlertModalComponent, {
        autoFocus: false,
        panelClass: 'dialog-modal',
        width: width,
        disableClose: disableClose,
        scrollStrategy: new NoopScrollStrategy(),
        data: {
          title: title ? title : 'Oops !',
          cancelBtn,
          confirmBtn,
          message: message
            ? message
            : "Due to an error, your application couldn't be sent. Please try again later.",
          icon: 'assets/icons/circle-cancel.svg',
        },
      });
    }
    // this.dialog.afterAllClosed.subscribe((res) => {
    //   return res;
    // });
    // return DialogRef.toPromise().catch((err) => {
    //   console.error(err);
    // });
    return this.DialogRef?.afterClosed();
  }
  closeAlertModal(data?: any): void {
    this.DialogRef.close(data);
  }
}
